import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG Components
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MenubarModule } from 'primeng/menubar';

// Components
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { HeroComponent } from './components/hero/hero.component';
import { CompanySectionComponent } from './components/company-section/company-section.component';
import { ServicesComponent } from './components/services/services.component';
import { AppShowcaseComponent } from './components/app-showcase/app-showcase.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { TeamComponent } from './components/team/team.component';
import { ContactComponent } from './components/contact/contact.component';
import { ProfileImageComponent } from './components/profile-image/profile-image.component';
import { TableToolbarComponent } from './components/table-toolbar/table-toolbar.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    // PrimeNG
    ButtonModule,
    InputTextModule,
    PasswordModule,
    CheckboxModule,
    SelectModule,
    CardModule,
    ToastModule,
    MenuModule,
    TableModule,
    DialogModule,
    ConfirmDialogModule,
    MenubarModule,
    // Standalone Components
    LanguageSelectorComponent,
    HeroComponent,
    CompanySectionComponent,
    ServicesComponent,
    AppShowcaseComponent,
    PricingComponent,
    TeamComponent,
    ContactComponent,
    ProfileImageComponent,
    TableToolbarComponent,
    CookieBannerComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    CheckboxModule,
    SelectModule,
    CardModule,
    ToastModule,
    MenuModule,
    TableModule,
    DialogModule,
    ConfirmDialogModule,
    MenubarModule,
    // Standalone Components
    LanguageSelectorComponent,
    HeroComponent,
    CompanySectionComponent,
    ServicesComponent,
    AppShowcaseComponent,
    PricingComponent,
    TeamComponent,
    ContactComponent,
    ProfileImageComponent,
    TableToolbarComponent,
    CookieBannerComponent
  ]
})
export class SharedModule { }